import { Component, OnInit, OnDestroy } from '@angular/core';
import { KeyingAuthService } from '../../../../../../apps/keycom/src/app/services/keying.auth.service';
import { NavService } from '../../../../../../apps/keycom/src/app/services/nav.service';
import { AppRoutingConfig } from '../../../../../../apps/keycom/src/app/configuration/app.routing.config';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { User } from '@overtur-monorepo/keying-user';
import { FeatureFlagService } from '@overtur-monorepo/keying-shared';

@Component({
  selector: 'app-feature-management-container',
  templateUrl: './feature-management-container.component.html',
  styleUrls: ['./feature-management-container.component.scss'],
  standalone: false
})
export class FeatureManagementContainerComponent implements OnInit, OnDestroy {
  destroy$ = new Subject();
  title = 'Feature Management';
  user!: User;

  profileActions = [{ name: 'logout', icon: 'logout', id: 0 }];
  helpActions = [
    { name: 'Support', icon: 'user', id: 0 },
  ];

  navButtons = [{ name: 'Home', active: true, icon: 'home', router: AppRoutingConfig.structuresUrl }];

  constructor(
    private authService: KeyingAuthService,
    private navService: NavService,
    private featureFlagService: FeatureFlagService
  ) {}

  ngOnInit(): void {
    // Reset navigation to show only Home button when on Features page
    this.navService.setEntities(this.navButtons);

    this.authService.keyingUser$.pipe(takeUntil(this.destroy$)).subscribe((user) => {
      if (user) {
        this.user = user;
      }
    });

    // Refresh feature flags when entering the feature management area
    this.featureFlagService.refreshAll();
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  helpAction(action: any): void {
  }

  profileAction(action: any): void {
    if (action.id === 0) {
      this.authService.logout();
    }
  }
}
